import {Flex,Alert} from '@aws-amplify/ui-react';


function ErrorAlert({title,message}){
    return (
        <Flex justifyContent="center" alignItems="center" margin=".5rem auto" height="80px"
          borderRadius="5%" padding="0 1rem" fontSize={"20px"}>
          <Alert 
            variation="error" 
            hasIcon={true} 
            isDismissible={true}
            borderRadius="10px"
            heading = {title}
          >
           {message}
          </Alert>
        </Flex>
        
      );
  }
  
  export default ErrorAlert;